<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="content">
    <img src="../assets/info.png" alt="" srcset="" class="img" />
    <h3 class="fs_22">招标投标信箱</h3>
    <!-- @handleItemTab="handleNowTab" -->
    <StepsView :stepList="stepList" :active="active" />
    <complainant v-show="active == 0" ref="complainantRef" />
    <beComplainant v-show="active == 1" ref="beComplainantRef" />
    <complaintContent v-show="active == 2" ref="complaintContentRef" />
    <uploading v-show="active == 3" ref="uploadingRef" />
    <accomplish v-show="active == 4" />
    <div class="flex">
      <!-- style="margin-left: 220px" -->
      <el-button
        @click="handleNext"
        class="bg"
        v-show="active == 0 || active == 1 || active == 2"
        >下一步</el-button
      >
      <el-button class="bg mb" v-show="active == 4" @click="goOne"
        >完成</el-button
      >
      <!-- style="margin-left: 220px" -->
      <el-button class="bg" v-show="active == 3" @click="handleSubmit"
        >提交</el-button
      >
      <!-- style="margin-top: 25px" -->
      <el-button
        @click="goPre"
        v-show="active == 1 || active == 2 || active == 3"
        >返回上一页</el-button
      >
    </div>
    <SendMsg
      :show.sync="sendMsgShow"
      :phone="complainantPhone"
      @getValidate="getValidate"
    />
  </div>
</template>

<script>
import complainant from '@/views/complainant'
import beComplainant from '@/views/beComplainant'
import complaintContent from '@/views/complaintContent'
import uploading from '@/views/uploading'
import accomplish from '@/views/accomplish'
import StepsView from '@/components/StepsView/index.vue'
import SendMsg from '@/components/SendMsg/index.vue'
// 接口
import { submitInfo } from '@/api/submit'
import { sm2 } from 'sm-crypto'

export default {
  components: {
    complainant,
    beComplainant,
    complaintContent,
    uploading,
    accomplish,
    StepsView,
    SendMsg
  },
  data() {
    return {
      active: 0,
      show: false,
      sendMsgShow: false, //验证身份对话框显示
      complainantPhone: 0, //投诉人联系方式
      hasValidate: false, //是否已经验证过身份
      validatePhone: 0, //验证的手机号
      stepList: [
        {
          name: '投诉人信息'
        },
        {
          name: '被投诉人信息'
        },
        {
          name: '投诉内容'
        },
        {
          name: '上传材料'
        },
        {
          name: '完成'
        }
      ],
      publicKey:
        '04de23eec74798ce7e7e299b6e710d1469acd5460fdeeecd1c36df441c09f7af5aa4ba0b55f5e0d2b09349ee55d66475b7efb300800e4dbe58293ff06cf524c59a'
    }
  },
  methods: {
    // 下一步判断
    async handleNext() {
      const flagA = await this.$refs.complainantRef.getComplainantForm()
      const flagB = await this.$refs.beComplainantRef.getBeForm()
      const flagC = await this.$refs.complaintContentRef.getContentForm()
      switch (this.active) {
        case 0:
          if (flagA) {
            this.complainantPhone =
              this.$refs.complainantRef.form.complainantContactPhone || 0
            if (!this.hasValidate) {
              this.sendMsgShow = true
            } else {
              this.next()
            }
          } else {
            this.$message({
              message: '信息未填完',
              type: 'warning'
            })
          }
          break
        case 1:
          if (flagB) {
            this.next()
          } else {
            this.$message({
              message: '信息未填完',
              type: 'warning'
            })
          }
          break
        case 2:
          if (flagC) {
            this.next()
          } else {
            this.$message({
              message: '信息未填完',
              type: 'warning'
            })
          }

          break
        default:
          '请填写信息'
          break
      }
    },
    async next() {
      if (this.active++ > 3) this.active = 0
      if (this.active > 0) this.show = true
    },
    //填写投诉人信息 下一步前验证身份回调
    getValidate(e) {
      if (e) {
        this.sendMsgShow = false
        this.hasValidate = true
        this.active = 1
      }
    },
    goPre() {
      if (this.active-- <= 0) this.active = 0
      if (this.active <= 0) this.show = false
    },
    // 完成
    goOne() {
      this.active = 0
      window.location.reload()
    },
    // 提交
    handleSubmit() {
      //   // 调用接口
      this.submit()
    },
    // 接口
    async submit() {
      const formData1 = this.$refs.complainantRef.form
      const formData2 = this.$refs.beComplainantRef.form
      const formData3 = this.$refs.complaintContentRef.form
      const formData4 = this.$refs.uploadingRef.form
      const complaintType = formData3.complaintType.join(',')
      if (formData4.files.length < 3) {
        this.$message({
          showClose: true,
          message: '前三项材料必须上传哦！',
          type: 'warning'
        })
        return
      }
      let formData5 = {
        ...formData1,
        ...formData2,
        ...{ ...formData3, complaintType },
        ...formData4
      }
      // sm2加密
      let encryptData = `04${sm2.doEncrypt(
        JSON.stringify(formData5),
        this.publicKey,
        1
      )}`
      let res = await submitInfo({ dataSecret: encryptData })
      if (res.success) {
        this.active = 4
        this.$message({
          message: '提交成功！',
          type: 'success'
        })
      } else {
        this.$message({
          message: '请确保信息都已填完再提交！',
          type: 'warning'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  position: relative;
}
.step {
  margin: 20px auto;
  cursor: pointer;
}
::v-deep .el-step__head.is-finish,
::v-deep .el-step__title.is-finish {
  color: #c0c4cc;
  border-color: #c0c4cc;
}
::v-deep .el-step__title.is-process,
::v-deep .el-step__head.is-process {
  color: #72ad43;
  border-color: #72ad43 !important;
}
.fs_22 {
  margin: 20px 220px 0px 260px;
  font-size: 22px;
}
.bg {
  background-color: #87a86c;
  color: #ffffff;
}
.mb {
  width: 85px;
  height: 45px;
  // margin: 76px 530px 0;
  font-size: 20px;
  position: absolute;
  left: 0;
  right: 0;
  top: 300px;
  bottom: 0;
  margin: auto;
}
.img {
  width: 30px;
  height: 30px;
  position: absolute;
  left: 218px;
  top: 0px;
}
.flex {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
